import { useState } from 'react';
import { locationIsKia } from '../../../utils/helpers';
import { AppProps } from '../../App';
import { usePage } from '../../hooks/usePage';
import Toolbar from '../components/toolbar';
import PageBuilder from '../pagebuilder';
import SlugSelector from './slug-selector';

export default function RenderWpPage({ uri }: Pick<AppProps, 'uri'>) {
  const queryString =
    typeof window !== 'undefined' ? window.location.search : '';
  const searchParams = new URLSearchParams(queryString);
  const pageParam = searchParams.get('wp');

  const [selectedSlug, setSelectedSlug] = useState<string | null>(pageParam);

  const handleSelectSlug = (slug: string | null) => {
    setSelectedSlug(slug);
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      if (slug) {
        params.set('wp', slug);
      } else {
        params.delete('wp');
      }
      window.history.replaceState(null, '', `?${params.toString()}`);
    }
  };

  const [isPreviewMode, setPreviewMode] = useState<boolean>(
    !locationIsKia() || !!pageParam,
  );

  const handleRefetch = () => {
    refetch();
  };

  const activeSlug = uri || selectedSlug || pageParam;

  const { data, isLoading, isError, error, refetch, isRefetching } = usePage(
    activeSlug || '',
    isPreviewMode,
  );

  if (!activeSlug && !locationIsKia()) {
    return (
      <div className="mx-auto max-w-lg">
        <h2 className="mb-4 text-xl font-bold">Välj en sida</h2>
        <SlugSelector onSelect={handleSelectSlug} />
      </div>
    );
  }

  if (isLoading && !locationIsKia())
    return <div className="p-4">Loading...</div>;

  if (isError) {
    console.error(error);
    if (locationIsKia() && isPreviewMode === false) {
      setPreviewMode(true);
    }
    return (
      <div className="p-8 text-red-600">
        <h2 className="font-bold">Error Loading Page</h2>
        <p>{error instanceof Error ? error.message : 'Unknown Error'}</p>

        {!locationIsKia() ||
          (!isPreviewMode && (
            <>
              <p className="text-black">
                Det kan vara så att denna sidan inte är publicerad och att det
                är därför du inte kan se <span className="font-bold">Live</span>{' '}
                verisonen.
              </p>
              <button
                onClick={() => setPreviewMode(true)}
                className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
              >
                Preview
              </button>
            </>
          ))}
      </div>
    );
  }

  return (
    <>
      {Boolean(uri) ||
        (!locationIsKia() ? (
          <Toolbar
            isPreviewMode={isPreviewMode}
            setPreviewMode={setPreviewMode}
            databaseId={
              data.kiaPage.databaseId ? data.kiaPage.databaseId : undefined
            }
            refetch={handleRefetch}
            isRefetching={isRefetching}
            uri={activeSlug}
          >
            <SlugSelector selected={selectedSlug} onSelect={handleSelectSlug} />
          </Toolbar>
        ) : null)}

      <PageBuilder blocks={data?.kiaPage?.pagebuilder?.blocks} />
    </>
  );
}
